import React from 'react';
import { FiArrowUpRight } from 'react-icons/fi';

const Button1 = ({ text, className = "" }) => {
  return (
    <button className={` relative inline-block  group ${className}`}>
      <span className="relative z-10 block px-5 py-3  overflow-hidden font-medium leading-tight text-gray-800 transition-colors duration-300 ease-out border-2 border-gray-900 rounded-lg group-hover:text-white">
        <span className="absolute inset-0 w-full h-full px-5 py-3 rounded-lg bg-gray-50"></span>
        <span className="absolute left-0 w-full h-[700px] transition-all duration-300 origin-top-right -rotate-90 -translate-x-full translate-y-12 bg-gray-900 group-hover:-rotate-180 ease"></span>
        <span className="relative flex items-center justify-center gap-3 uppercase">
          {text} <FiArrowUpRight className="text-xl" />
        </span>
      </span>
      <span
        className="absolute bottom-0 right-0 w-full h-12 mb-1 -mr-1 transition-all duration-200 ease-linear bg-gray-900 rounded-lg group-hover:mb-0 group-hover:mr-0"
        data-rounded="rounded-lg"
      ></span>
    </button>
  );
};

export default Button1;